import React, { useState } from "react";
import "moment/locale/pt-br";

import { ModuleHeader } from '~/components/ModuleHeader';
import { Icon, Radio, Dropdown, Menu, Button, Popover, Badge } from "antd";
import Import from "./Import";
import FilterPillsBar from '~/_shared/components/FilterPillsBar';

export const Header = ({
  showDrawer,
  isSeventhOnboardingStepActive,
  displayMode,
  setDisplayMode,
}) => {
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);

  return (
    <>
      <Import
        visible={isImportModalVisible}
        onCancel={() => setIsImportModalVisible(false)}
      />
      <ModuleHeader
        breadcrumbs={['CRM', 'INSS Obra']}
        title={<span>INSS Obra</span>}
        center={
          <>
            <Popover
              trigger="click"
              placement="bottomRight"
              content={
                <div style={{ width: 280 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                    <span style={{ fontSize: 15, fontWeight: 600, color: '#262626' }}>Filtros</span>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#8c8c8c', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Visualizacao</div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                      {[
                        { value: 'funnel', label: 'Funil', color: '#722ed1', icon: 'funnel-plot' },
                        { value: 'table', label: 'Tabela', color: '#1890ff', icon: 'table' },
                      ].map(function(opt) {
                        var isActive = displayMode === opt.value;
                        return (
                          <div
                            key={opt.value}
                            onClick={function() { setDisplayMode(opt.value); }}
                            style={{
                              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                              padding: '6px 10px', borderRadius: 6, cursor: 'pointer',
                              border: '1.5px solid ' + (isActive ? opt.color : '#e8e8e8'),
                              background: isActive ? opt.color + '0a' : '#fafafa',
                              transition: 'all 0.2s',
                            }}
                          >
                            <span style={{ fontSize: 12, color: isActive ? '#262626' : '#8c8c8c' }}>
                              <Icon type={opt.icon} style={{ marginRight: 4 }} />
                              {opt.label}
                            </span>
                            {isActive && <Icon type="check" style={{ color: opt.color, fontSize: 12 }} />}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              }
            >
              <Badge
                count={1}
                offset={[-4, 0]}
                style={{ backgroundColor: '#722ed1' }}
              >
                <Button icon="bars" style={{ borderRadius: 8 }}>Filtros</Button>
              </Badge>
            </Popover>
            <Button icon="plus" shape="circle" onClick={function() { showDrawer(); }} />
          </>
        }
        advanced={
          React.createElement(FilterPillsBar, {
            pills: [
              { key: 'mode', label: displayMode === 'funnel' ? 'Funil' : 'Tabela', color: displayMode === 'funnel' ? '#722ed1' : '#1890ff', icon: displayMode === 'funnel' ? 'funnel-plot' : 'table' },
            ],
          })
        }
      />
    </>
  );
};